import React, {useState} from 'react'
import {Modal, Container} from 'react-bootstrap'
// import FormPass from 'components/componentsmall/form_pass'
import './style.css'

export default function AkunKurir() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (
      <> 
          <img onClick={handleShow} src="asset/kupon.svg" alt="kupon" />
  
        <Modal className="ber-update-profile" size="lg" show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Pilih Kupon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Container>
              <div className="akun-content-berberkah">
                  <div className="div-kupon">
                       <input type="text" id="form-kupon" />
                       <button>Pakai</button>
                  </div>
                  <div className="kupon-tersedia">
                       <div className="kupon-price">
                            <img src="asset/logo_kupon.png" alt="kupon" />
                            <div className="img-kupon">       
                                    <p>Kupon Potongan Rp. 50.000</p>
                                    <small>Syarat dan Ketentuan</small>
                            </div>
                       </div>
                       <button>Gunakan</button>
                  </div>
              </div>
          </Container>
          </Modal.Body>
        </Modal>
      </>
    );
  }
  